import { useState, useEffect } from 'react';

// Open-Meteo: current conditions + 7-day cumulative precipitation.
// Single fetch shared by the Météo-Conseil banner and the weather widget status bar.
export const useMeteoConseil = (lat = 46.6983, lon = -1.7633) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const fetchMeteo = async () => {
      try {
        const res = await fetch(
          `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}` +
            `&current=temperature_2m,wind_speed_10m,precipitation,weather_code` +
            `&daily=precipitation_sum,temperature_2m_max` +
            `&past_days=7&forecast_days=1&timezone=Europe/Paris`
        );
        if (!res.ok) return;
        const json = await res.json();
        if (active) setData(json);
      } catch (e) {
        console.error('Météo-Conseil fetch error:', e);
      } finally {
        if (active) setLoading(false);
      }
    };
    fetchMeteo();
    return () => {
      active = false;
    };
  }, [lat, lon]);

  if (!data?.current) {
    return { loading, conseil: null };
  }

  const temp = data.current.temperature_2m;
  const wind = data.current.wind_speed_10m;
  const precipNow = data.current.precipitation;

  const precipSeries = data.daily?.precipitation_sum || [];
  // Last 7 days (exclude today, which is the final entry when forecast_days=1)
  const rain7d = precipSeries
    .slice(0, 7)
    .reduce((sum, v) => sum + (typeof v === 'number' ? v : 0), 0);
  // Today's rain (forecast for the current day) = final daily entry
  const rain24h = precipSeries.length
    ? precipSeries[precipSeries.length - 1]
    : precipNow;

  const alerts = {
    canicule: temp > 32,
    gel: temp < 2,
    vent: wind > 40,
    eau: rain7d < 10 && temp > 25,
  };

  // Status du Jour — priority: suspendu > vigilance > idéal
  let status = 'ideal';
  if (temp > 34 || wind > 45 || temp < 0) {
    status = 'suspendu';
  } else if (temp > 30 || rain24h > 5) {
    status = 'vigilance';
  } else if (rain24h < 1 && temp < 28) {
    status = 'ideal';
  } else {
    status = 'vigilance';
  }

  return {
    loading,
    conseil: { temp, wind, precipNow, rain7d, rain24h, alerts, status },
  };
};

export default useMeteoConseil;
